/* CAP CARE — interacciones propias (sin librerías) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enEditor = window.Shopify && window.Shopify.designMode;
  if (enEditor) document.documentElement.classList.add('cc-editor');

  /* ---- Apariciones al hacer scroll (un solo observador) ---- */
  var observador = null;
  function initReveal(raiz) {
    var els = (raiz || document).querySelectorAll('.cc-reveal, .cc-reveal-img, .cc-hero');
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cc-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('cc-visible'); observador.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* ---- Parallax suave del hero ---- */
  function initParallax() {
    if (reducido) return;
    var heroes = document.querySelectorAll('[data-cc-parallax]');
    if (!heroes.length) return;
    var pendiente = false;
    function mover() {
      heroes.forEach(function (h) {
        var media = h.querySelector('.cc-hero__media');
        var fuerza = parseFloat(h.getAttribute('data-cc-parallax')) || 0;
        if (!media || !fuerza) return;
        var r = h.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        media.style.transform = 'translate3d(0,' + (-r.top * fuerza / 100) + 'px,0)';
      });
      pendiente = false;
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(mover); }
    }, { passive: true });
    mover();
  }

  /* ---- FAQ: solo una abierta a la vez (opcional) ---- */
  function initFaq(raiz) {
    (raiz || document).querySelectorAll('[data-cc-faq-unica]').forEach(function (lista) {
      lista.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          lista.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---- Galería de producto ---- */
  function initGaleria(raiz) {
    (raiz || document).querySelectorAll('[data-cc-galeria]').forEach(function (g) {
      var principal = g.querySelector('.cc-galeria__principal img');
      var minis = Array.prototype.slice.call(g.querySelectorAll('.cc-galeria__mini'));
      if (!principal || !minis.length) return;
      var actual = 0;
      function ir(i) {
        if (i < 0) i = minis.length - 1;
        if (i >= minis.length) i = 0;
        actual = i;
        var m = minis[i];
        minis.forEach(function (x) { x.setAttribute('aria-current', x === m ? 'true' : 'false'); });
        var marco = principal.parentElement, vid = marco.querySelector('.cc-galeria__video');
        if (m.hasAttribute('data-video')) {
          marco.classList.add('cc-ver-video');
          if (vid) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
          m.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          return;
        }
        marco.classList.remove('cc-ver-video');
        if (vid) vid.pause();
        principal.classList.add('cc-cambiando');
        setTimeout(function () {
          principal.srcset = m.getAttribute('data-srcset');
          principal.src = m.getAttribute('data-src');
          principal.alt = m.getAttribute('data-alt') || '';
          principal.classList.remove('cc-cambiando');
        }, 220);
        m.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      g._ccIr = ir;
      g._ccIdx = function (id) { return minis.findIndex(function (x) { return x.getAttribute('data-media-id') === String(id); }); };
      minis.forEach(function (m, i) { m.addEventListener('click', function () { ir(i); }); });
      var prev = g.querySelector('[data-cc-prev]'), next = g.querySelector('[data-cc-next]');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      var x0 = null;
      principal.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.parentElement.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  /* ---- Variantes, cantidad y barra móvil ---- */
  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-cc-producto]').forEach(function (p) {
      var datos = p.querySelector('[data-cc-variantes]');
      var form = p.querySelector('form[action*="/cart/add"]');
      var inputId = form && form.querySelector('input[name="id"]');
      var boton = p.querySelector('[data-cc-anadir]');
      var precio = p.querySelector('[data-cc-precio]');
      var antes = p.querySelector('[data-cc-precio-antes]');
      var ahorro = p.querySelector('[data-cc-ahorro]');
      var barraPrecio = document.querySelector('[data-cc-barra-precio]');
      var textoAnadir = boton ? boton.getAttribute('data-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';
      var formato = p.getAttribute('data-cc-formato') || '${{amount}}';

      function dinero(c) {
        var n = (c / 100);
        var con = function (dec, mil, sepDec) {
          var partes = n.toFixed(dec).split('.');
          partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil);
          return partes.join(sepDec);
        };
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, t) {
          if (t === 'amount_no_decimals') return con(0, ',', '.');
          if (t === 'amount_with_comma_separator') return con(2, '.', ',');
          if (t === 'amount_no_decimals_with_comma_separator') return con(0, '.', ',');
          if (t === 'amount_with_apostrophe_separator') return con(2, "'", '.');
          if (t === 'amount_with_space_separator') return con(2, ' ', ',');
          return con(2, ',', '.');
        });
      }

      if (datos && form) {
        var variantes = JSON.parse(datos.textContent);
        p.addEventListener('change', function (e) {
          if (!e.target.closest('.cc-opcion')) return;
          var elegidas = Array.prototype.map.call(p.querySelectorAll('.cc-opcion'), function (fs) {
            var c = fs.querySelector('input:checked'); return c ? c.value : null;
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
          if (!v) { if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; } return; }
          inputId.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (barraPrecio) barraPrecio.textContent = dinero(v.price);
          if (antes) { antes.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
          if (ahorro) { ahorro.hidden = !(v.compare_at_price > v.price); }
          if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? textoAnadir : textoAgotado; }
          if (v.featured_media) {
            var g = p.querySelector('[data-cc-galeria]');
            if (g && g._ccIdx) { var i = g._ccIdx(v.featured_media.id); if (i > -1) g._ccIr(i); }
          }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      }

      p.querySelectorAll('[data-cc-cantidad]').forEach(function (c) {
        var input = c.querySelector('input');
        c.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-paso'), 10);
            input.value = Math.max(1, v);
          });
        });
      });

      var barra = document.querySelector('[data-cc-barra]');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { barra.classList.toggle('cc-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(boton);
        var b2 = barra.querySelector('button');
        if (b2) b2.addEventListener('click', function () { if (boton && !boton.disabled) boton.click(); });
      }
    });
  }

  function iniciar(raiz) {
    initReveal(raiz); initFaq(raiz); initGaleria(raiz); initProducto(raiz);
  }

  document.addEventListener('DOMContentLoaded', function () { iniciar(document); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); initParallax(); });
})();

/* ==========================================================================
   CAP CARE — efectos avanzados: espuma, antes/después, cifras, burbujas, 3D
   ========================================================================== */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esMovil = function () { return window.matchMedia('(max-width: 989px)').matches; };

  /* ---------- Motor de espuma (canvas) ---------- */
  function Espuma(seccion) {
    var lienzo = seccion.querySelector('.cc-espuma__lienzo');
    var botella = seccion.querySelector('[data-cc-botella]');
    var img = botella && botella.querySelector('img');
    if (!lienzo || !img) return;
    var ctx = lienzo.getContext('2d');
    var bx = parseFloat(seccion.dataset.boquillaX) / 100;
    var by = parseFloat(seccion.dataset.boquillaY) / 100;
    var ang = parseFloat(seccion.dataset.angulo) * Math.PI / 180;
    var dens = parseFloat(seccion.dataset.densidad) || 110;
    var tam = parseFloat(seccion.dataset.tamano) || 7;
    var auto = (parseFloat(seccion.dataset.auto) || 4) * 1000;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var p = [], emitir = 0, activo = false, ultimo = 0, origen = { x: 0, y: 0 }, escala = 1, animando = false;

    function medir() {
      var r = lienzo.getBoundingClientRect();
      lienzo.width = r.width * dpr; lienzo.height = r.height * dpr;
      var ri = img.getBoundingClientRect();
      origen.x = (ri.left - r.left + ri.width * bx) * dpr;
      origen.y = (ri.top - r.top + ri.height * by) * dpr;
      escala = Math.max(.55, ri.width / 520) * dpr;
    }
    function crear(fuerza) {
      var abanico = (Math.random() - .5) * .9;
      var v = (1.4 + Math.random() * 3.4) * fuerza * escala;
      p.push({
        x: origen.x + (Math.random() - .5) * 4 * escala,
        y: origen.y + (Math.random() - .5) * 4 * escala,
        vx: Math.cos(ang + abanico) * v,
        vy: Math.sin(ang + abanico) * v - .4 * escala,
        r: (tam * .35 + Math.random() * tam) * escala * (Math.random() < .12 ? 1.9 : 1),
        crece: 1 + Math.random() * .012,
        vida: 0, max: 230 + Math.random() * 260,
        osc: Math.random() * 6.28
      });
    }
    function dibujar(b, alfa) {
      var g = ctx.createRadialGradient(b.x - b.r * .35, b.y - b.r * .35, b.r * .1, b.x, b.y, b.r);
      g.addColorStop(0, 'rgba(255,255,255,' + (.95 * alfa) + ')');
      g.addColorStop(.6, 'rgba(250,247,240,' + (.72 * alfa) + ')');
      g.addColorStop(1, 'rgba(225,220,210,' + (.35 * alfa) + ')');
      ctx.beginPath(); ctx.arc(b.x, b.y, b.r, 0, 6.2832); ctx.fillStyle = g; ctx.fill();
      ctx.lineWidth = Math.max(.6, b.r * .08); ctx.strokeStyle = 'rgba(255,255,255,' + (.55 * alfa) + ')'; ctx.stroke();
      if (b.r > 3 * dpr) { ctx.beginPath(); ctx.arc(b.x - b.r * .38, b.y - b.r * .4, b.r * .18, 0, 6.2832); ctx.fillStyle = 'rgba(255,255,255,' + alfa + ')'; ctx.fill(); }
    }
    function cuadro(t) {
      var dt = Math.min(2.5, (t - (ultimo || t)) / 16.67); ultimo = t;
      ctx.clearRect(0, 0, lienzo.width, lienzo.height);
      if (emitir > 0) {
        var n = p.length > 900 ? 0 : Math.round(dens / 11 * dt);
        for (var i = 0; i < n; i++) crear(Math.min(1.2, .45 + emitir / 40));
        emitir -= dt;
      }
      for (var k = p.length - 1; k >= 0; k--) {
        var b = p[k];
        b.vida += dt;
        b.vx *= Math.pow(.955, dt); b.vy = b.vy * Math.pow(.955, dt) + .026 * escala * dt;
        b.osc += .05 * dt;
        b.x += (b.vx + Math.sin(b.osc) * .15 * escala) * dt; b.y += b.vy * dt;
        if (b.r < tam * 2.4 * escala) b.r *= Math.pow(b.crece, dt);
        var alfa = b.vida < 8 ? b.vida / 8 : (b.vida > b.max - 40 ? Math.max(0, (b.max - b.vida) / 40) : 1);
        if (b.vida >= b.max || b.y > lienzo.height + 40) { p.splice(k, 1); continue; }
        dibujar(b, alfa);
      }
      if (p.length || emitir > 0) { requestAnimationFrame(cuadro); } else { animando = false; ultimo = 0; ctx.clearRect(0, 0, lienzo.width, lienzo.height); }
    }
    function disparo(duracion) {
      if (reducido) return;
      medir();
      emitir = Math.max(emitir, duracion || 34);
      botella.classList.remove('cc-pulsa'); void botella.offsetWidth; botella.classList.add('cc-pulsa');
      if (!animando) { animando = true; requestAnimationFrame(cuadro); }
    }
    botella.addEventListener('click', function () { disparo(60); });
    window.addEventListener('resize', medir);
    if (img.complete) medir(); else img.addEventListener('load', medir);

    /* Escena por scroll (ordenador) o automática (móvil) */
    var frases = seccion.querySelectorAll('.cc-espuma__frase');
    var barras = seccion.querySelectorAll('.cc-espuma__progreso span');
    var pasoActual = -1, temporizador = null;
    function irPaso(i) {
      if (i === pasoActual) return;
      var adelante = i > pasoActual;
      pasoActual = i;
      frases.forEach(function (f, j) { f.classList.toggle('cc-activa', j === i); f.classList.toggle('cc-pasada', j < i); });
      barras.forEach(function (b, j) { b.classList.toggle('cc-activa', j <= i); });
      if (adelante) disparo(45 + i * 12);
    }
    function alScroll() {
      if (esMovil()) return;
      var r = seccion.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (r.top > window.innerHeight * .5 || r.bottom < 0) return;
      var prog = Math.min(.999, Math.max(0, -r.top / Math.max(1, total)));
      irPaso(Math.floor(prog * frases.length));
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(alScroll); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          activo = e.isIntersecting;
          clearInterval(temporizador);
          if (activo) {
            if (esMovil()) { disparo(36); temporizador = setInterval(function () { disparo(32); }, auto); }
            else alScroll();
          }
        });
      }, { threshold: .25 }).observe(seccion);
    }
  }

  /* ---------- Comparador antes / después ---------- */
  function Comparador(el) {
    var control = el.querySelector('.cc-comparador__control');
    if (!control) return;
    var poner = function (v) { el.style.setProperty('--cc-pos', v + '%'); };
    control.addEventListener('input', function () { poner(control.value); });
    if (control.dataset.auto === 'true' && !reducido && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        var inicio = parseFloat(control.value), t0 = null;
        var ruta = function (t) { // 50 → 22 → 78 → inicio
          if (t < .33) return inicio + (22 - inicio) * Math.sin(t / .33 * Math.PI / 2);
          if (t < .75) return 22 + 56 * (1 - Math.cos((t - .33) / .42 * Math.PI)) / 2;
          return 78 + (inicio - 78) * Math.sin((t - .75) / .25 * Math.PI / 2);
        };
        function paso(ts) {
          if (!t0) t0 = ts;
          var t = Math.min(1, (ts - t0) / 2600), v = ruta(t);
          control.value = v; poner(v);
          if (t < 1) requestAnimationFrame(paso);
        }
        setTimeout(function () { requestAnimationFrame(paso); }, 500);
      }, { threshold: .5 });
      io.observe(el);
    }
  }

  /* ---------- Cifras que cuentan ---------- */
  function Contador(el) {
    var fin = parseFloat(el.getAttribute('data-cc-contar')) || 0;
    if (reducido || !('IntersectionObserver' in window)) { el.textContent = fin; return; }
    el.textContent = '0';
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      var t0 = null, dur = 1600 + Math.min(fin, 200) * 4;
      function paso(ts) {
        if (!t0) t0 = ts;
        var t = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - t, 4);
        el.textContent = Math.round(fin * e).toLocaleString('es-CO');
        if (t < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }, { threshold: .6 });
    io.observe(el);
  }

  /* ---------- Burbujas suaves y brillo que sigue al cursor en el hero ---------- */
  function HeroVivo(hero) {
    if (reducido) return;
    if (hero.dataset.ccBurbujas === 'true') {
      var c = document.createElement('canvas'); c.className = 'cc-hero__burbujas'; hero.insertBefore(c, hero.querySelector('.cc-hero__contenido'));
      var ctx = c.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), bs = [], visible = true;
      var medir = function () { c.width = c.offsetWidth * dpr; c.height = c.offsetHeight * dpr; };
      medir(); window.addEventListener('resize', medir);
      for (var i = 0; i < 26; i++) bs.push({ x: Math.random(), y: Math.random(), r: 2 + Math.random() * 9, v: .0004 + Math.random() * .0012, o: Math.random() * 6.28 });
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) requestAnimationFrame(loop); }).observe(hero);
      function loop() {
        if (!visible) return;
        ctx.clearRect(0, 0, c.width, c.height);
        bs.forEach(function (b) {
          b.y -= b.v; b.o += .01; if (b.y < -.05) { b.y = 1.05; b.x = Math.random(); }
          var x = (b.x + Math.sin(b.o) * .01) * c.width, y = b.y * c.height, r = b.r * dpr;
          ctx.beginPath(); ctx.arc(x, y, r, 0, 6.2832);
          ctx.strokeStyle = 'rgba(226,200,146,.28)'; ctx.lineWidth = dpr; ctx.stroke();
          ctx.beginPath(); ctx.arc(x - r * .35, y - r * .35, r * .18, 0, 6.2832); ctx.fillStyle = 'rgba(255,240,210,.35)'; ctx.fill();
        });
        requestAnimationFrame(loop);
      }
    }
    var luz = document.createElement('div'); luz.className = 'cc-hero__cursor'; hero.appendChild(luz);
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      luz.style.transform = 'translate(' + (e.clientX - r.left) + 'px,' + (e.clientY - r.top) + 'px)';
    });
  }

  /* ---------- Tarjetas con inclinación 3D ---------- */
  function Inclinar(el) {
    if (reducido || window.matchMedia('(hover: none)').matches) return;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      el.style.transform = 'perspective(900px) rotateY(' + (x * 7) + 'deg) rotateX(' + (-y * 7) + 'deg) translateY(-4px)';
    });
    el.addEventListener('pointerleave', function () { el.style.transform = ''; });
  }

  /* ---------- Barra dorada de progreso de lectura ---------- */
  function Progreso() {
    if (document.querySelector('.cc-progreso-pagina') || !document.querySelector('.cc-section')) return;
    var b = document.createElement('div'); b.className = 'cc-progreso-pagina'; document.body.appendChild(b);
    window.addEventListener('scroll', function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      b.style.transform = 'scaleX(' + (h > 0 ? window.scrollY / h : 0) + ')';
    }, { passive: true });
  }

  function iniciar(raiz) {
    raiz.querySelectorAll('[data-cc-espuma]').forEach(Espuma);
    raiz.querySelectorAll('[data-cc-comparador]').forEach(Comparador);
    raiz.querySelectorAll('[data-cc-contar]').forEach(Contador);
    raiz.querySelectorAll('.cc-hero').forEach(HeroVivo);
    raiz.querySelectorAll('[data-cc-tilt]').forEach(Inclinar);
  }
  document.addEventListener('DOMContentLoaded', function () { iniciar(document); Progreso(); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();

/* ---------- Compra directa: va al pago solo con este producto ---------- */
document.addEventListener("submit", function (e) {
  var form = e.target;
  if (!form.querySelector || !form.querySelector("[data-cc-directo]")) return;
  var id = form.querySelector("input[name=\"id\"]");
  if (!id || !id.value) return;
  var q = form.querySelector("input[name=\"quantity\"]");
  var cant = Math.max(1, parseInt(q && q.value, 10) || 1);
  e.preventDefault();
  var b = form.querySelector("[type=submit]"); if (b) { b.disabled = true; b.classList.add("cc-cargando"); }
  window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/" + id.value + ":" + cant;
});

/* ---------- Vídeo con scroll: fotogramas fundidos con zoom ---------- */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function VideoScroll(sec) {
    if (sec._cc) return; sec._cc = true;
    var lienzo = sec.querySelector('.cc-vs__lienzo'), ctx = lienzo.getContext('2d');
    var base = sec.dataset.base, pref = sec.dataset.prefijo, n = parseInt(sec.dataset.cuadros, 10) || 1;
    var foco = parseFloat(sec.dataset.foco) || .5;
    var desplazar = (parseFloat(sec.dataset.desplazar) || 0) / 100;
    var capas = Array.prototype.slice.call(sec.querySelectorAll('.cc-vs__capa'));
    var barra = sec.querySelector('.cc-vs__barra span');
    var imgs = [], cargadas = 0, prog = 0, dibujado = -1, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var fundir = n <= 12; // pocos fotogramas = fundido cinematográfico; muchos = vídeo real
    for (var i = 1; i <= n; i++) {
      var num = ('00' + i).slice(-3);
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { cargadas++; if (cargadas === 1 || cargadas === n) { sec.classList.add('cc-listo'); dibujado = -1; pintar(); } };
      im.src = base.replace(pref + '001', pref + num);
      imgs.push(im);
    }
    function medir() { lienzo.width = lienzo.clientWidth * dpr; lienzo.height = lienzo.clientHeight * dpr; dibujado = -1; pintar(); }
    function cubrir(im, alfa, zoom) {
      if (!im || !im.complete || !im.naturalWidth) return;
      var cw = lienzo.width, ch = lienzo.height, r = Math.max(cw / im.naturalWidth, ch / im.naturalHeight) * zoom;
      var w = im.naturalWidth * r, h = im.naturalHeight * r;
      var horizontal = cw > ch * 1.1;
      var x = (cw - w) * (cw < ch ? foco : .5) + (horizontal ? cw * desplazar : 0), y = (ch - h) / 2;
      ctx.globalAlpha = alfa; ctx.drawImage(im, x, y, w, h);
    }
    function pintar() {
      if (prog === dibujado) return; dibujado = prog;
      var pos = prog * (n - 1), i = Math.floor(pos), f = pos - i;
      var zoom = 1 + prog * .08;
      ctx.globalAlpha = 1; ctx.fillStyle = '#0E0D0B'; ctx.fillRect(0, 0, lienzo.width, lienzo.height);
      if (fundir) {
        var t = Math.min(1, Math.max(0, (f - .3) / .4)); var e = t * t * (3 - 2 * t); // fundido solo en el tramo central: menos «doble imagen»
        cubrir(imgs[i], 1, zoom); if (e > 0.001 && imgs[i + 1]) cubrir(imgs[i + 1], e, zoom);
      } else {
        cubrir(imgs[Math.round(pos)] && imgs[Math.round(pos)].complete ? imgs[Math.round(pos)] : imgs[i], 1, zoom);
      }
      ctx.globalAlpha = 1;
      if (desplazar && lienzo.width > lienzo.height * 1.1) {
        var gx = lienzo.width * desplazar * 1.6, gr = ctx.createLinearGradient(0, 0, gx, 0);
        gr.addColorStop(0, 'rgba(14,13,11,1)'); gr.addColorStop(.55, 'rgba(14,13,11,.85)'); gr.addColorStop(1, 'rgba(14,13,11,0)');
        ctx.fillStyle = gr; ctx.fillRect(0, 0, gx, lienzo.height);
      }
    }
    function alScroll() {
      var r = sec.getBoundingClientRect(), total = r.height - window.innerHeight;
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var p = Math.min(1, Math.max(0, -r.top / Math.max(1, total)));
      prog = reducido ? 0 : Math.round(p * 1000) / 1000;
      var pc = p * 100;
      capas.forEach(function (c) {
        var d = parseFloat(c.dataset.desde), h = parseFloat(c.dataset.hasta);
        c.classList.toggle('cc-activa', pc >= d && (pc < h || (h >= 100 && pc >= 99.5)));
      });
      if (barra) barra.style.transform = 'scaleX(' + p + ')';
      sec.classList.toggle('cc-avanzado', p > .02);
      pintar();
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(alScroll); }, { passive: true });
    window.addEventListener('resize', medir);
    medir(); alScroll();
  }
  function iniciar(r) { r.querySelectorAll('[data-cc-vs]').forEach(VideoScroll); }
  document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
